export const faq = [
    {
        id: 1,
        title: 'How much does a new boiler cost?',
        body: 'The cost of a new boiler depends on a number of factors such as the size of your home and the number of bathrooms you have. For an accurate price click here to get an instand quote. You do not need to enter your phone number or personal details to get an instant price'
    },
    {
        id: 2,
        title: 'Do you offer finance for new boilers?',
        body: 'Yes we offer a range for finance deals to help you purchase your new boiler. All boilers are available with 0% finance and zero desposit'
    },
    {
        id: 3,
        title: 'Does a salesman visit my home?',
        body: `No, here at AquaHeat we don't use salesman. You can get a full price instantly online without entering personal details. If you're happy with the price you can pay and book for your install online. However, if you would prefer a heating engineer to visit your home to do a survey we can arrange this`,
    }

]